export const TABLE_COLOUMN_ORDER_BY = "sku";
export const TABLE_SPAN = 13;
export const TABLE_NAME = "Inventory Table";
export const TABLE_ID = "inventory-table";
export const CLICK_PAGE_URL = "/inventory-detail/";
export const CLICK_PAGE_TITLE = "View Details";
